import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-7xl mx-auto px-4 sm:px-6" }
const _hoisted_2 = { class: "2xl:container 2xl:mx-auto md:py-12 lg:px-20 md:px-6 py-9 px-4" }
const _hoisted_3 = { class: "w-full flex flex-col justify-content-center items-center" }
const _hoisted_4 = { class: "font-semibold lg:text-4xl text-3xl lg:leading-9 md:leading-7 leading-9 text-curaduria" }
const _hoisted_5 = { class: "lg:text-lg text-lg text-justify lg:leading-9 md:leading-7 leading-9 text-black mt-2 font-normal" }
const _hoisted_6 = {
  role: "list",
  class: "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 mt-6"
}
const _hoisted_7 = { class: "mt-10" }
const _hoisted_8 = { class: "font-semibold lg:text-4xl text-3xl lg:leading-9 md:leading-7 leading-9 text-curaduria text-center" }
const _hoisted_9 = {
  role: "list",
  class: "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 mt-6"
}
const _hoisted_10 = { class: "relative bg-gray-300 rounded-lg shadow mt-8" }
const _hoisted_11 = { class: "max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8" }
const _hoisted_12 = { class: "pr-16 sm:text-center sm:px-16" }
const _hoisted_13 = { class: "font-medium text-[16px] text-curaduriaDark" }
const _hoisted_14 = { class: "md:hidden" }
const _hoisted_15 = { class: "hidden md:inline" }
const _hoisted_16 = { class: "block sm:ml-2 sm:inline-block" }
const _hoisted_17 = {
  href: "https://drive.google.com/drive/folders/1M7D_N4XENbo5ijeddlmkoceRQc0wmszn?usp=share_link",
  target: "_blank",
  class: "text-curaduriaDark font-bold underline"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
const _hoisted_19 = { class: "relative bg-gray-300 rounded-lg shadow mt-2" }
const _hoisted_20 = { class: "max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8" }
const _hoisted_21 = { class: "pr-16 sm:text-center sm:px-16" }
const _hoisted_22 = { class: "font-medium text-[16px] text-curaduriaDark" }
const _hoisted_23 = { class: "md:hidden" }
const _hoisted_24 = { class: "hidden md:inline" }
const _hoisted_25 = { class: "block sm:ml-2 sm:inline-block" }
const _hoisted_26 = {
  href: "https://drive.google.com/drive/folders/1zWh_LEZhj161RoEySI29fxF_w_KavWkv?usp=share_link",
  target: "_blank",
  class: "text-curaduriaDark font-bold underline"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
const _hoisted_28 = { class: "relative bg-gray-300 rounded-lg shadow mt-2" }
const _hoisted_29 = { class: "max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8" }
const _hoisted_30 = { class: "pr-16 sm:text-center sm:px-16" }
const _hoisted_31 = { class: "font-medium text-[16px] text-curaduriaDark" }
const _hoisted_32 = { class: "md:hidden" }
const _hoisted_33 = { class: "hidden md:inline" }
const _hoisted_34 = { class: "block sm:ml-2 sm:inline-block" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "→", -1)

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Resolution = _resolveComponent("Resolution")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("resolutions.title")), 1),
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("resolutions.des")), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("ul", _hoisted_6, [
            _createVNode(_component_Resolution, {
              title: 2021,
              description: _ctx.$t('resolutions.res2021'),
              navigateTo: 'https://drive.google.com/drive/folders/1WP4T2OOk90dXTPbIAoL61WxEQv8L9tb_'
            }, null, 8, ["description", "navigateTo"]),
            _createVNode(_component_Resolution, {
              title: 2022,
              description: _ctx.$t('resolutions.res2022'),
              navigateTo: 'https://drive.google.com/drive/folders/1jAqqrnv33eTnin1Z5wPnsrFl7bmap5U2'
            }, null, 8, ["description", "navigateTo"]),
            _createVNode(_component_Resolution, {
              title: 2023,
              description: _ctx.$t('resolutions.res2022'),
              navigateTo: 'https://drive.google.com/drive/folders/1YaLswDRZ7ei95Ez8mqD68daF4el101Xr'
            }, null, 8, ["description", "navigateTo"]),
            _createVNode(_component_Resolution, {
              title: 2024,
              description: _ctx.$t('resolutions.res2024'),
              navigateTo: 'https://drive.google.com/drive/folders/1Lo6PBt6_LtbZBkAsuaJnKi96UqgMm9a6'
            }, null, 8, ["description", "navigateTo"]),
            _createVNode(_component_Resolution, {
              title: 2025,
              description: _ctx.$t('resolutions.res2025'),
              navigateTo: 'https://drive.google.com/drive/folders/1lObR3gs52yO6sZ7FQkvKrh_DVxTwYXUL'
            }, null, 8, ["description", "navigateTo"]),
            _createVNode(_component_Resolution, {
              title: 2026,
              description: _ctx.$t('resolutions.res2026'),
              navigateTo: 'https://drive.google.com/drive/folders/1oCkpWvgkwyYFsrV_NlApeu1D0h1X41FX?usp=sharing'
            }, null, 8, ["description", "navigateTo"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t("resolutions.vecinos")), 1),
          _createElementVNode("ul", _hoisted_9, [
            _createVNode(_component_Resolution, {
              title: 2025,
              description: _ctx.$t('resolutions.vec2025'),
              navigateTo: 'https://drive.google.com/drive/folders/1fWPbgfh6ZZZYF1hlRVe4i23kmgtZW41q'
            }, null, 8, ["description", "navigateTo"]),
            _createVNode(_component_Resolution, {
              title: 2026,
              description: _ctx.$t('resolutions.vec2026'),
              navigateTo: 'https://drive.google.com/drive/folders/1TLMZ0Mzc7K-0PugOXKbzWJy4eTjGH7pw'
            }, null, 8, ["description", "navigateTo"]),
            _createVNode(_component_Resolution, {
              title: 2027,
              description: _ctx.$t('resolutions.vec2027'),
              navigateTo: 'https://drive.google.com/drive/folders/1M1E3T3YgumG6_aoKUkTOGPTumzqHQlrP'
            }, null, 8, ["description", "navigateTo"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("resolutions.denied")), 1),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("resolutions.denied")), 1),
                _createElementVNode("span", _hoisted_16, [
                  _createElementVNode("a", _hoisted_17, [
                    _createTextVNode(_toDisplayString(_ctx.$t("resolutions.btnGoText")) + " ", 1),
                    _hoisted_18
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("p", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("resolutions.otherAct")), 1),
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("resolutions.otherAct")), 1),
                _createElementVNode("span", _hoisted_25, [
                  _createElementVNode("a", _hoisted_26, [
                    _createTextVNode(_toDisplayString(_ctx.$t("resolutions.btnGoText")) + " ", 1),
                    _hoisted_27
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("p", _hoisted_31, [
                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("resolutions.others")), 1),
                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("resolutions.others")), 1),
                _createElementVNode("span", _hoisted_34, [
                  _createVNode(_component_router_link, {
                    to: "/otrasResoluciones",
                    class: "k font-bold underline"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("resolutions.btnGoText")) + " ", 1),
                      _hoisted_35
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}